import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import httpClient from "@/tools/http-client";

export const useNewsItemStore
    = defineStore('NewsItemStore', () => {

    const crud = useCrudStore(environment.appConfig.baseApiUrl + "top-news");


    async function loadTopNews() {
        console.log("loadTopNews");
        crud.startLoading();
        try {
            const resp = await httpClient.post(crud.endpoint.value, {top_count: 5});
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.setData(resp.data.news);
            crud.clearLoading();
        } catch (e) {
            crud.setError(e);
        }
    }

    return {
        ...crud,
        loadTopNews,
    }
});
